import retry from 'retry';

export async function retryPromise<T>(func: () => Promise<T>, options: retry.OperationOptions) {
    const operation = retry.operation(options);

    return new Promise((resolve, reject) => {
        operation.attempt(() => {
            Promise.resolve(func())
                .then(r => resolve(r))
                .catch(err => {
                    if (operation.retry(err)) {
                        return;
                    }

                    reject(operation.mainError());
                });
        })
    });
}
